import GetProfileConfigInfo from "../entities/getProfileConfigInfo";
import ProfileConfig from "../entities/profileConfig";
import { OnboardingRepository } from "../repositories/OnboardingRepository";

export class SendProfileConfig {
	constructor(private repository: OnboardingRepository) {}

	execute(params: SendProfileConfigParams): Promise<GetProfileConfigInfo> {
		return this.repository.sendProfileConfig(params.data);
	}
}

export class SendProfileConfigParams {
	constructor(public data: ProfileConfig) {}
}
